// extracted by mini-css-extract-plugin
module.exports = {"date":"ProcedureTableInfo_date__K1n0G","head":"ProcedureTableInfo_head__28-pW"};